import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { AlertContext } from "contexts/Alert";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";

import { REFERRAL_CREDIT } from "utils/influencer";
import { trackEvent } from "utils/tracking";

interface Props {
  open: boolean;
  close: () => void;
}

const styles = {
  referralCode: {
    px: 2,
    py: 1,
    display: "flex",
    border: "2px dashed",
    borderColor: "secondary.main",
    backgroundColor: "secondary.light",
    borderRadius: 2,
    cursor: "pointer",
    maxWidth: 400,
  },
  code: {
    flexGrow: 1,
    mr: 4,
  },
  iconButton: {
    position: "absolute",
    right: 4,
    top: 4,
    width: 30,
    height: 30,
    color: grey[500],
    fontSize: 16,
  },
};

const ReferralDialog = ({ open, close }: Props) => {
  const { setAlert } = useContext(AlertContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { referralCode } = useContext(SubscriptionContext);
  const handleCopyToClipboard = () => {
    if (referralCode) {
      navigator.clipboard.writeText(referralCode);
    }

    trackEvent("Referral Link Copied to Clipboard", {
      source: "Referral Dialog",
    });

    setAlert("Copied to clipboard!", "success");
  };

  useEffect(() => {
    if (open) {
      trackEvent("Referral Dialog Shown");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={close}
      fullScreen={isMobileScreen}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography variant="h4" textAlign="center" component="div">
          Have you been enjoying Bento? <br />
        </Typography>
        <Box
          sx={{
            fontSize: 50,
            mt: 2,
            justifyContent: "center",
            display: "flex",
          }}
        >
          🎁
        </Box>
        <IconButton aria-label="close" onClick={close} sx={styles.iconButton}>
          <Box component="i" className="fa-regular fa-xmark" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Typography textAlign="center" sx={{ mb: 2 }}>
          Earn Bento's site credits by referring your friends, giving you more
          opportunities to send emails and secure deals!{" "}
        </Typography>

        <Typography textAlign="center" sx={{ mb: 2 }}>
          Give ${REFERRAL_CREDIT} in credit. Earn ${REFERRAL_CREDIT} credit when
          they upgrade.
        </Typography>

        <Typography textAlign="center">
          Here's your unique referral link:{" "}
        </Typography>

        <Grid container justifyContent="center">
          <Box sx={styles.referralCode} onClick={handleCopyToClipboard}>
            <Box sx={styles.code}>{referralCode}</Box>
            <Box
              component="i"
              sx={{ lineHeight: "1.25" }}
              className="fa-regular fa-copy fa-lg"
            />
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ReferralDialog;
